import isEmail from 'validator/lib/isEmail';
import hasEmoji from './hasEmoji';

// Don't support non-ascii characters (those that have been converted to "xn--")
export default (input: string) => isEmail(input) && !hasEmoji(input) && !/@xn--/.test(input);
